import { DataFarmType } from '../domainObjects/dataFarmType';
import { ColumnMapDefinitionModel } from '../model/columnMapDefinitionModel';
import { DataConnectorViewModel } from './dataConnectorViewModel';
import { v4 as uuidv4 } from 'uuid';


export class DataFarmViewModel {
    guid: string;
    id: number;
    name: string;
    columnMappings: Array<ColumnMapDefinitionModel>;
    dataConnector: DataConnectorViewModel<any>;
    dataFarmType: DataFarmType;
    columns: Array<string>;
    
    constructor(
      id: number,
      name: string,
      columnMappings: Array<ColumnMapDefinitionModel>,
      columns: Array<string>,
      dataConnector: DataConnectorViewModel<any>,
      dataFarmType: DataFarmType,
      guid?: string) {

      this.guid = guid ?? uuidv4();
      this.id = id;
      this.name = name;
      this.columnMappings = columnMappings;
      this.columns = columns;
      this.dataConnector = dataConnector;
      this.dataFarmType = dataFarmType;
    }
}
